import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../core/config/config.service';
import { Pagina } from '../models/pagina.model';
import {
  TenantAtualizarRequestDTO,
  TenantCriarRequestDTO,
  TenantFiltros,
  TenantResponseDTO,
} from '../models/tenant.model';

@Injectable({ providedIn: 'root' })
export class TenantService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(ConfigService);

  /** `pagina` base 0. Filtros vazios não vão na query. */
  listar(
    filtros: TenantFiltros,
    pagina: number,
    tamanho: number,
  ): Observable<Pagina<TenantResponseDTO>> {
    let params = new HttpParams().set('pagina', pagina).set('tamanho', tamanho);
    const busca = filtros.busca?.trim();
    if (busca) {
      params = params.set('busca', busca);
    }
    if (filtros.modo) {
      params = params.set('modo', filtros.modo);
    }
    if (filtros.onda !== null && filtros.onda !== undefined) {
      params = params.set('onda', filtros.onda);
    }
    if (filtros.habilitado) {
      params = params.set('habilitado', filtros.habilitado);
    }
    if (filtros.clienteId) {
      params = params.set('clienteId', filtros.clienteId);
    }
    return this.http.get<Pagina<TenantResponseDTO>>(`${this.apiUrl}/tenants`, { params });
  }

  buscar(id: number): Observable<TenantResponseDTO> {
    return this.http.get<TenantResponseDTO>(`${this.apiUrl}/tenants/${id}`);
  }

  criar(request: TenantCriarRequestDTO): Observable<TenantResponseDTO> {
    return this.http.post<TenantResponseDTO>(`${this.apiUrl}/tenants`, request);
  }

  atualizar(id: number, request: TenantAtualizarRequestDTO): Observable<TenantResponseDTO> {
    return this.http.put<TenantResponseDTO>(`${this.apiUrl}/tenants/${id}`, request);
  }

  alterarHabilitado(id: number, habilitado: boolean): Observable<TenantResponseDTO> {
    return this.http.patch<TenantResponseDTO>(`${this.apiUrl}/tenants/${id}/habilitado`, {
      habilitado,
    });
  }

  private get apiUrl(): string | undefined {
    return this.config.settings()?.apiUrl;
  }
}
